/**
 * Divider.tsx
 * Composant séparateur horizontal ou vertical
 * Utilise Tailwind CSS pour le styling
 */
import React from 'react';
import { cn } from '../utils/cn';

export interface DividerProps extends React.HTMLAttributes<HTMLDivElement> {
  orientation?: 'horizontal' | 'vertical';
  label?: string;
}

export const Divider = React.forwardRef<HTMLDivElement, DividerProps>(
  ({ orientation = 'horizontal', label, className, ...props }, ref) => {
    if (orientation === 'vertical') {
      return (
        <div
          ref={ref}
          className={cn('w-px bg-gray-200 self-stretch', className)}
          role="separator"
          aria-orientation="vertical"
          {...props}
        />
      );
    }

    if (label) {
      return (
        <div
          ref={ref}
          className={cn('flex items-center gap-3 my-4', className)}
          role="separator"
          aria-label={label}
          {...props}
        >
          <div className="flex-1 h-px bg-gray-200" />
          <span className="text-xs text-gray-500">{label}</span>
          <div className="flex-1 h-px bg-gray-200" />
        </div>
      );
    }

    return (
      <div
        ref={ref}
        className={cn('h-px bg-gray-200 my-4', className)}
        role="separator"
        aria-orientation="horizontal"
        {...props}
      />
    );
  }
);

Divider.displayName = 'Divider';
